import * as messageService from "../../services/message.service";
import * as employmentStatusService from '../../services/employmentStatus.service';


const state = {
    employmentStatusAll:[],
    employmentStatusAllActive:[],
};

const getters = {
    gettEmploymentStatusAll:state => (state.employmentStatusAll),
    gettEmploymentStatusActive:state => (state.employmentStatusAllActive),
};

const actions = {
    async fetchEmploymentStatusAll({ commit } ){
        try {
            const response = await employmentStatusService.all();
            commit('setEmploymentStatusAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchEmploymentStatusAllActive({ commit } ){
        try {
            const response = await employmentStatusService.allActive();
            commit('setEmploymentStatusAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setEmploymentStatusAll:(state, res) => (
        state.employmentStatusAll =  res
    ),
    setEmploymentStatusAllActive:(state, res) => (
        state.employmentStatusAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}